export const DDC_MAP_ZOOM = 'ddc.map.zoom';

function zoom(map) {
	return {
		eventType: DDC_MAP_ZOOM,
		eventData: {
			// the map's container element, so pushEvent enrichment can
			// resolve the widget (widgetName/widgetHeading) it lives in
			element: map?.getDiv?.()
		}
	};
}

export default zoom;
